export default "__VITE_ASSET__C6G564vG__"